import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';

export default {
  namespaced: true,
  state: {
    isFetching: false,
    loaderReplacementsGet: false,
    loaderBrandsGet: false,
    part_number: '',
    tableReplacements:{
      img: '',
      showTitle: false,
      title: '',
      subTitle: '',
      items :[],
      show: false
    },
    tableBrandsGet: [],
    applicability: {
      items:[],
      show: false
    },
    time: '',
    replacementsFor: {
      part_number: '',
      brand: ''
    },
    userExcludedCrosses:[],
    userCrosses:[]

    //choosePartPartCode, 'brand':this.choosePartBrandName
  },
  getters:{
    getField, //vuex-map-fields

  },
  mutations: {
    updateField, //vuex-map-fields
    setUserCrosses(state, data) {
      state.userExcludedCrosses = data.excluded_crosses || [];
      if(data.user_crosses.length>0){
        let array = [];
        let user_crosses = data.user_crosses;
        for(let j in user_crosses){
          array[user_crosses[j].brand_name+':'+data.user_crosses[j].search_number]=true;
        }
        state.userCrosses = array;
      }
    },
    setApplicabilityShow(state, data) {
      state.applicability.show = data;
    },
    setApplicability(state, data) {
      state.applicability.items = data;
    },
    setTableBrandsGetItems(state, data) {
      state.tableBrandsGet = data;
    },
    setTableReplacementsItems(state, data) {
      //let data = state.tableReplacements.items;
      state.tableReplacements.items = [];
      let ex = [];
      if(state.userExcludedCrosses!=[]){
        ex = state.userExcludedCrosses.map((one)=>{
          let res = one.split(':');
          return {
            'brand_name':res[0],
            'aliases':{},
            'search_number':res[1],
            'part_name':'',
            'images_small':[],
            'isExcludedCross':true
          };
        });
      }
      data = data.concat(ex);
      state.tableReplacements.items = data;
    },
    setTableReplacementsTitle(state, data) {
      state.tableReplacements.title = data;
    },
    setTableReplacementsImg(state, data) {
      state.tableReplacements.img = data;
    },
    setTableReplacementsSubTitle(state, data) {
      state.tableReplacements.subTitle = data;
    },
    setTableReplacementsShow(state, data) {
      state.tableReplacements.show = data;
    },
    setTime(state, data) {
      state.time = data;
    },
  },
  actions: {
    replacementsGet: function ({commit, state, dispatch}) {
      commit('setTableReplacementsShow', false);
      commit('setTableReplacementsImg', null);
      state.loaderReplacementsGet = true;
      let userCrossesExist = false;
      return axios.get(this._vm.$apiURL + '/am/crosses/partcrosses', {
        params: {
          'part_number': state.replacementsFor.part_number,
          'brand': state.replacementsFor.brand
        }
      })
        .then((response) => {
          commit('setUserCrosses', response.data);
          userCrossesExist = (response.data.user_crosses.length > 0) || (response.data.excluded_crosses.length > 0);
        })
        .then(() => {
          return axios.post(this._vm.$apiURL + '/am-api', {
            'method': 'ReplacementsGet',
            data: {'part_number': state.replacementsFor.part_number, 'brand': state.replacementsFor.brand}
          })
            .then((response) => {
              commit('setTableReplacementsShow', false);
              if (response.data.error) {
                if (error.response.data.errors) {
                  this._vm.$error(Object.entries(error.response.data.errors)[0][1][0])
                } else {
                  this._vm.$error(error.response.statusText);
                }
              } else {
                if (response) {
                  if (response.data) {
                    commit('setTableReplacementsItems', response.data.replacements);
                    if (userCrossesExist || (response.data.replacements.length > 0 || false)) commit('setTableReplacementsShow', true);
                    if (response.data.time) {
                      commit('setTime', response.data.time || '');
                    }
                    if (response.data.requested_part) {

                      commit('setTableReplacementsTitle', response.data.requested_part.brand_name + ' - ' + response.data.requested_part.search_number);
                      commit('setTableReplacementsSubTitle', response.data.requested_part.part_name);


                      if (response.data.requested_part.images.length > 0) {
                        commit('setTableReplacementsImg', response.data.requested_part.images[0]);
                      }

                      commit('setApplicabilityShow', false);
                      commit('setApplicability', []);

                      if (response.data.requested_part.applicability) {

                        if (response.data.requested_part.applicability instanceof Object) {
                          if (Object.values(response.data.requested_part.applicability).length > 0) {
                            commit('setApplicabilityShow', true);
                            commit('setApplicability', Object.entries(response.data.requested_part.applicability));
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            .catch((error) => {
              state.loaderReplacementsGet = false;
              dispatch('common/showError', {'error': error}, {root:true});
            })
          //state.loaderReplacementsGet = true;
        })
        .catch((error) => {
          state.loaderReplacementsGet = false;
          dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(() => {
          state.loaderReplacementsGet = false;
        })


    },
    brandsGet({commit, state, dispatch}){
      state.loaderBrandsGet = true;
      return axios.post(this._vm.$apiURL+'/am-api', {'method':'BrandsGet', data: {'part_number':state.part_number}})
        .then((response) => {
          state.loaderBrandsGet = true;
          if(response.data.error){
            if(response.data.errors){
              this._vm.$error(Object.entries(error.response.data.errors)[0][1][0])
            } else {
              dispatch('common/showError', {'error': response.data.error}, {root:true});
            }
            state.loaderBrandsGet = false;
          } else {
            if(response.data.time){
              commit('setTime', response.data.time || '');
            }
            commit('setTableBrandsGetItems', response.data.parts);
          }

        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
          state.loaderBrandsGet = false;
        })
    },
    async deleteCross({commit, state, dispatch}, payload){
      return await this._vm.$confirm( {
        title : this._vm.i18n.t('common.confirm'),
        text : this._vm.i18n.t('viewAMSearch.confirm_delete_cross'),
        cancelText : this._vm.i18n.t('common.no'),
        acceptText : this._vm.i18n.t('common.yes')
      } ).then( async y =>{
        state.loaderReplacementsGet = true;
        return await axios.delete(this._vm.$apiURL+'/am/crosses/delete',
          {
            data: {
              'for_part_number':state.replacementsFor.part_number,
              'for_brand_name':state.replacementsFor.brand,
              'brand_name':payload.brandName,
              'part_number':payload.partNumber,
            }
          })
          .then((response) => {
            return response;
          })
          .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
          })
      })
    },
    async restoreCross({commit, state, dispatch}, payload){
      return await axios.post(this._vm.$apiURL+'/am/crosses/restore',
        {
          'for_part_number':state.replacementsFor.part_number,
          'for_brand_name':state.replacementsFor.brand,
          'brand_name':payload.brandName,
          'part_number':payload.partNumber,
        })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        });
    }
  }
}
